(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1104],{

/***/ 52646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akoestische-panelen",
      function () {
        return __webpack_require__(5964);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_components_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63269);
/* harmony import */ var _modules_layout_templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77092);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _modules_common_render_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41702);





var AkoestischePanelen = function(param) {
    var post = param.post;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), params = ref6[0], setParams = ref6[1];
    var items = post === null || post === void 0 ? void 0 : post.content;
    var ref7, ref8, ref9;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_components_head__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: (ref7 = post === null || post === void 0 ? void 0 : (ref = post.seo) === null || ref === void 0 ? void 0 : ref.metaTitle) !== null && ref7 !== void 0 ? ref7 : post === null || post === void 0 ? void 0 : post.title,
                description: post === null || post === void 0 ? void 0 : (ref1 = post.seo) === null || ref1 === void 0 ? void 0 : ref1.metaDescription,
                canonical: post === null || post === void 0 ? void 0 : (ref2 = post.seo) === null || ref2 === void 0 ? void 0 : ref2.canonicalURL,
                robots: (ref8 = post === null || post === void 0 ? void 0 : (ref3 = post.seo) === null || ref3 === void 0 ? void 0 : ref3.metaRobots) !== null && ref8 !== void 0 ? ref8 : "index, follow",
                image: (ref9 = post === null || post === void 0 ? void 0 : (ref4 = post.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metaImage) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref9 !== void 0 ? ref9 : null
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grain-background",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative small:absolute z-20 bg-red-600 text-white p-3 small:rounded-full text-[0.8rem] small:text-[19px] small:right-10 small:top-10 text-center w-full md:w-[200px] small:aspect-square flex items-center justify-center",
                                children: [
                                    "GRATIS VERZENDEN ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    "VAN AKUPANELEN"
                                ]
                            }),
                            items && items.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    item: item
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 z-0 pointer-events-none",
                        style: {
                            background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                        },
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
};
AkoestischePanelen.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_layout_templates__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (AkoestischePanelen);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9128,3662,3415,1228,5445,5937,4617,6158,6556,3815,6659,2931,7092,1702,9774,2888,179], function() { return __webpack_exec__(52646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);